import { useTranslation } from "react-i18next"

import { Search } from "@/components/icons"
import { Button } from "@/components/ui/button"

type AdminGlobalSearchTriggerProps = {
  onOpen: () => void
}

/** Opens the admin global search palette; mirrors the Ctrl/Cmd+K shortcut. */
export function AdminGlobalSearchTrigger({ onOpen }: AdminGlobalSearchTriggerProps) {
  const { t } = useTranslation()
  // Read synchronously (guarded for the node test env) like the other kbd
  // hints in this codebase — an effect would render "Ctrl K" first and flicker.
  const isMac = typeof navigator !== "undefined" && navigator.platform.toUpperCase().includes("MAC")

  return (
    <Button
      className="text-muted-foreground min-h-11 justify-start gap-2 font-normal sm:w-64"
      type="button"
      variant="outline"
      onClick={onOpen}
    >
      <Search aria-hidden="true" className="size-4 shrink-0" />
      <span className="truncate">{t("adminDashboard.globalSearch.trigger", "Search admin…")}</span>
      <kbd className="bg-muted text-muted-foreground ml-auto hidden rounded px-1.5 py-0.5 text-[11px] font-medium sm:inline-block">
        {isMac ? "⌘K" : "Ctrl K"}
      </kbd>
    </Button>
  )
}
